import React from 'react';
import { View, Image, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { useTheme } from '../contexts/ThemeContext';

interface PageContainerProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  backgroundColor?: string;
}

/**
 * PageContainer - A reusable wrapper component with pattern background
 * Use this component to wrap page content for consistent styling across the app
 * Automatically uses theme colors when no backgroundColor is provided
 */
export default function PageContainer({
  children,
  style,
  backgroundColor,
}: PageContainerProps) {
  const { colors, isDark } = useTheme();
  const bgColor = backgroundColor ?? colors.background;

  return (
    <View style={[styles.container, { backgroundColor: bgColor }, style]}>
      {/* Pattern Background - hidden in dark mode for better contrast */}
      {!isDark && (
        <Image
          source={require('../../assets/images/Pattern BG.svg')}
          style={styles.patternBackground}
          resizeMode="cover"
        />
      )}
      {/* Content */}
      <View style={styles.content} role="main">
        {children}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: 'relative',
  },
  patternBackground: {
    ...StyleSheet.absoluteFillObject,
    width: '100%',
    height: '100%',
    opacity: 0.5,
  },
  content: {
    flex: 1,
    zIndex: 1,
  },
});
